/** Web: titreşim API’si yok; no-op. */
export async function impactLight(): Promise<void> {}
